var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcMenuClone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 37.95C14.2 37.95 13.5 37.6499 12.9 37.0499C12.3 36.4499 12 35.75 12 34.95V6.94995C12 6.14995 12.3 5.44995 12.9 4.84995C13.5 4.24995 14.2 3.94995 15 3.94995H37C37.8 3.94995 38.5 4.24995 39.1 4.84995C39.7 5.44995 40 6.14995 40 6.94995V34.95C40 35.75 39.7 36.4499 39.1 37.0499C38.5 37.6499 37.8 37.95 37 37.95H15ZM15 34.95H37V6.94995H15V34.95ZM9 43.95C8.2 43.95 7.5 43.6499 6.9 43.0499C6.3 42.4499 6 41.75 6 40.95V10.8H9V40.95H32.7V43.95H9ZM15 6.94995V34.95V6.94995Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuClone);
export default __webpack_public_path__ + "static/media/ic-menu-clone.240bb215e161b9dbb0be911bd5969663.svg";
export { ForwardRef as ReactComponent };